import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectAccountActivation = createSelector(
  [(state: AppState) => state.shared.accountActivation],
  accountActivation => accountActivation,
);
